import server_api from "data/server_apis/server_api";
// Location
export const getLocations = () => {
  return server_api.get("/vending/location");
};
export const createLocation = (data) => {
  return server_api.post("/vending/location", data);
};
export const updateLocation = (id, data) => {
  return server_api.patch(`/vending/location/${id}`, data);
};
export const deleteLocation = (id) => {
  return server_api.delete(`/vending/location/${id}`);
};
// Assign Location
export const assignLocation = (data) => {
  return server_api.post("/vending/assign-machine-to-location", data);
};
// Assign location admin to Location
export const assignLocationAdminToLocation = (data) => {
  return server_api.post("/vending/assign-location-admin-to-location", data);
};

export const removeLocationAdminToLocation = (data) => {
  return server_api.post(
    "/vending/assign-location-admin-to-location/remove_location_admin",
    data
  );
};

//Main Stock
export const mainStockTransaction = (data) => {
  return server_api.post("/stock/main-stock-transaction", data);
};
export const mainStockLogs = (page, from_date = "", to_date = "") => {
  return server_api.get(
    `/stock/main-stock-transaction?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}`
  );
};
export const getMainStock = () => {
  return server_api.get(`/stock/main-stock?page`);
};

export const getMainStockHistory = (time) => {
  return server_api.get(`/stock/main-stock/get-history?time=${time}`);
};

//Distributor Stock
export const distributorStockTransaction = (data) => {
  return server_api.post("/stock/distributor-stock-transaction", data);
};
export const distributorStockLogs = (
  page,
  from_date = "",
  to_date = "",
  distributor = ""
) => {
  return server_api.get(
    `/stock/distributor-stock-transaction?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}&distributor=${distributor}`
  );
};
export const getDistributorStock = (distributor) => {
  return distributor
    ? server_api.get(`/stock/distributor-stock?distributor=${distributor}`)
    : server_api.get(`/stock/distributor-stock`);
};

export const getDistributorStockHistory = (time, distributor) => {
  return server_api.get(
    `/stock/distributor-stock/get-history?time=${time}&distributor=${distributor}`
  );
};

//Admin Stock
export const adminStockTransaction = (data) => {
  return server_api.post("/stock/admin-stock-transaction", data);
};
export const adminStockLogs = (
  page,
  from_date = "",
  to_date = "",
  admin = ""
) => {
  return server_api.get(
    `/stock/admin-stock-transaction?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}&admin=${admin}`
  );
};
export const getAdminStock = (admin) => {
  return admin
    ? server_api.get(`/stock/admin-stock?admin=${admin}`)
    : server_api.get(`/stock/admin-stock`);
};

export const getAdminStockHistory = (time, admin) => {
  return server_api.get(
    `/stock/admin-stock/get-history?time=${time}&admin=${admin}`
  );
};

//Location Stock
export const locationStockTransaction = (data) => {
  return server_api.post("/stock/location-stock-transaction", data);
};
export const locationStockLogs = (
  page,
  from_date = "",
  to_date = "",
  location = ""
) => {
  return server_api.get(
    `/stock/location-stock-transaction?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}&location=${location}`
  );
};
export const getLocationStock = (location) => {
  return location
    ? server_api.get(`/stock/location-stock?location=${location}`)
    : server_api.get(`/stock/location-stock`);
};

export const getLocationStockHistory = (time, location) => {
  return server_api.get(
    `/stock/location-stock/get-history?time=${time}&location=${location}`
  );
};

//Location Stock
export const fillingPersonStockTransaction = (data) => {
  return server_api.post("/stock/filling-person-stock-transaction", data);
};
export const fillingPersonStockLogs = (
  page,
  from_date = "",
  to_date = "",
  filling_person = ""
) => {
  return server_api.get(
    `/stock/filling-person-stock-transaction?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}&filling_person=${filling_person}`
  );
};
export const getFillingPersonStock = (filling_person) => {
  return filling_person
    ? server_api.get(`/stock/filling-person-stock?filling_person=${filling_person}`)
    : server_api.get(`/stock/filling-person-stock`);
};

export const getFillingPersonStockHistory = (time, filling_person) => {
  return server_api.get(
    `/stock/filling-person-stock/get-history?time=${time}&filling_person=${filling_person}`
  );
};

export const fillingPersonReturn = (
  page,
  from_date = "",
  to_date = "",
  filling_person = ""
) => {
  return server_api.get(
    `/stock/filling-person-stock-transaction/get_returns?page=${page}&date_iso_after=${from_date}&date_iso_before=${to_date}&filling_person=${filling_person}`
  );
};

export const readFillingPersonReturn = (
  id
) => {
  return server_api.get(
    `/stock/filling-person-stock-transaction/${id}/read-item`
  );
};

// Inventory settings
export const getInventorySettings = () => {
  return server_api.get("/stock/stock-settings");
};

export const setInventorySettings = (data) => {
  return server_api.post("/stock/stock-settings", data);
};

